export const random = arr => arr[Math.floor(Math.random() * arr.length)];
export const asOptions = arr => arr.map(r => ({ value: r.id, label: r.name }));
